import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import './institute-automation.css';
import Overview from './components/Overview';
import GlobalSettings from './components/GlobalSettings';
import ClientSettings from './components/ClientSettings';
import ModuleHeader, { ModuleTab } from './components/ModuleHeader';
import { InstituteRow } from './instituteAutomationService';

const InstituteAdminReports: React.FC = () => {
    const [params] = useSearchParams();
    const tabParam = params.get('tab');
    const tab: ModuleTab = (['overview', 'global', 'client'].includes(tabParam || '') ? tabParam : 'overview') as ModuleTab;

    const [toastMsg, setToastMsg] = useState<string | null>(null);
    const toastTimer = useRef<ReturnType<typeof setTimeout> | null>(null);
    const navigate = useNavigate();

    const toast = (msg: string) => {
        setToastMsg('✔ ' + msg);
        if (toastTimer.current) clearTimeout(toastTimer.current);
        toastTimer.current = setTimeout(() => setToastMsg(null), 3000);
    };
    useEffect(() => () => { if (toastTimer.current) clearTimeout(toastTimer.current); }, []);

    // Preview happens on the standalone page (no Preview tab in the dashboard).
    const openPreview = (inst: InstituteRow) =>
        navigate(`/institute-automation-report-preview?institute_id=${encodeURIComponent(inst.id)}&name=${encodeURIComponent(inst.name)}`);

    return (
        <div className="iar main p-3 p-md-4 bg-light flex-1">
            <div className="max-1250 mx-auto">
                <ModuleHeader active={tab} />

                <div className="screen" style={{ display: tab === 'overview' ? 'block' : 'none' }}>
                    <Overview onPreview={openPreview} />
                </div>
                <div className="screen" style={{ display: tab === 'global' ? 'block' : 'none' }}>
                    <GlobalSettings toast={toast} />
                </div>
                <div className="screen" style={{ display: tab === 'client' ? 'block' : 'none' }}>
                    <ClientSettings toast={toast} />
                </div>
            </div>

            {/* TOAST */}
            <div className="toast-container position-fixed bottom-0 end-0 p-3" style={{ zIndex: 1080 }}>
                <div className={`toast align-items-center text-white bg-dark border-0${toastMsg ? ' show' : ''}`} role="alert" aria-live="assertive" aria-atomic="true">
                    <div className="d-flex">
                        <div className="toast-body font-12 font-600 py-2">{toastMsg}</div>
                        <button type="button" className="btn-close btn-close-white me-2 m-auto" aria-label="Close" onClick={() => setToastMsg(null)} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InstituteAdminReports;
